module.exports = __webpack_public_path__ + "img/6brice.46091b99.jpg";